/**
 * Created by wjy on 2018-10-11
 */
import * as React from 'react';
import { observer } from 'mobx-react/custom';
import { inject } from 'mobx-react';
import Utils from '@chehejia/club-lib/lib/utils/Utils';
import QRCode from 'qrcodejs2';
import './index.scss';
import serviceLogIn,{unJwt} from './../../../../service/login/LoginService'
@inject('store')
@observer
export default class Login extends React.Component<any, any> {
    public securityStr; // 防盗安全序列
    public timer;
    public getCodeTimer;

    public public;

    public constructor(props) {
        super(props);
        this.init();
    }
    public async getLoginCode() {
        clearTimeout(this.getCodeTimer);
        this.securityStr = Utils.UUID();
        const param: any = {};
        param.securityChain = this.securityStr;
        param.businessId = 2;
        param.barcodeType = 1;
        // this.props.store.dataLogCodeModel.init(param).then((res) => {
        //     console.log('获取二维码成功', res);
        //     // this.getLoginCodeStatus(this.securityStr, res.qrCode);
        //     clearInterval(this.timer);
        //     this.timer = setInterval(() => {
        //         this.getLoginCodeStatus(this.securityStr, res.barcode, param.businessId);
        //     }, 2000);
        // }).catch((err) => {
        //     console.log('数据请求失败 ', err);
        // });

        // this.getCodeTimer = setTimeout(() => {
        //     this.getLoginCode();
        // }, 30000);
        const codeUrl = await this.props.store.dataLogCodeModel.init();
        // 生成二维码
        new QRCode('lixiangCode', {
            text: codeUrl,
            width: 200,
            height: 200,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H
        });
        // 轮训接口
        const code = await serviceLogIn.loopCodeState((code)=>{
          console.log(code,'code')
          const userInfo =  unJwt(code)
          console.log(userInfo)
    
          userInfo.avatar =userInfo.picture
          // 更新当前信息
          window.localStorage.setItem('USERINFO', JSON.stringify(userInfo));
           // 跳转到首页
          this.props.hasLogin();
        })
        
    }

    public getLoginCodeStatus(
        securityChain: string,
        barcode: string,
        businessId: number
    ) {
        this.props.store.dataLogCodeStatus
            .init(securityChain, barcode, businessId)
            .then(res => {
                console.log('获取二维码状态成功', res);
                if (res.status === 2) {
                    // 执行获取token接口res
                    console.log('授权成功', res);
                    clearInterval(this.timer);
                    this.getLoginToken(res.st);
                } else {
                    // 授权失败
                    console.log('授权失败');
                    // this.getLoginCode();
                }
            })
            .catch(err => {
                console.log('获取二维码状态失败', err);
            });
    }

    public getLoginToken(st) {
        const param = {
            authCode: st || 'null',
            loginType: 3
        };
        this.props.store.dataLoginToken
            .init(param)
            .then(res => {
                console.log('获取token成功', res);
                const userInfo = JSON.stringify(res);
                window.localStorage.setItem('ACCESSTOKEN', res.token);
                window.localStorage.setItem('USERINFO', userInfo);
                this.props.hasLogin();
            })
            .catch(err => {
                console.log('获取token失败', err);
            });
    }

    public init() {
        this.state = {
            //
        };
    }

    public componentWillMount() {
        // const deviceid = Utils.UUID();
        // console.log(deviceid);
        /*  if (localStorage.getItem('USERINFO')) {
            window.location.href = '/';
        } else { */
        this.getLoginCode();
        // }
    }

    public componentDidMount() {
        // document.title = '理想社群文章发布平台';
    }

    public componentWillUnmount() {
        clearInterval(this.timer);
        clearTimeout(this.getCodeTimer);
    }

    public render() {
        const { dataLogCodeModel } = this.props.store;
        return (
            <div className="qrcode-box">
                <div className="loginCodePic" id="lixiangCode"></div>
                {/* <div className="loginCodePic"><img src={dataLogCodeModel.base64} alt="" /></div> */}
                <p>使用理想APP扫码登录</p>
            </div>
        );
    }
}
